<div class="error-page-container">
  <h1>HTTP {{status}}</h1>
  <h2>Upps, {{message}} :(</h2>
  <h3>{{error}}</h3>
  <button mat-stroked-button color="primary" type="button" routerLink="/">Start</button>
</div>
